import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class BookingDotComActionAdapter extends ApplicationV1Adapter {}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'booking-dot-com-action': BookingDotComActionAdapter;
  }
}
